// extracted by mini-css-extract-plugin
module.exports = {"box":"BoxSpinner_box__2tsAw"};